module.exports = __webpack_public_path__ + "img/item2.f3698685.png";